import React from 'react';

const SystemStats = ({ totalResults, darkMode }) => {
  return (
    <div className="p-4 rounded-lg bg-gradient-to-r from-blue-500 to-purple-600 text-white">
      <h4 className="text-md font-semibold mb-4">Toplam Değerler</h4>
      <div className="space-y-2">
        <div className="flex justify-between">
          <span>Toplam Kapasite:</span>
          <span className="font-bold">{Math.round(totalResults.totalCapacity)} kW</span>
        </div>
        <div className="flex justify-between">
          <span>Ortalama COP:</span>
          <span className="font-bold">{totalResults.avgCOP.toFixed(1)}</span>
        </div>
        <div className="flex justify-between">
          <span>Toplam Tasarruf:</span>
          <span className="font-bold">{Math.round(totalResults.totalSavings)}K €</span>
        </div>
        <div className="flex justify-between">
          <span>Toplam CO₂:</span>
          <span className="font-bold">{Math.round(totalResults.totalCO2)} Ton</span>
        </div>
      </div>
    </div>
  );
};

export default SystemStats;